import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import Dialog from "@mui/material/Dialog";
import { colors } from "healthex-common/colors";
import { HXIconButton } from "./HXButton";
import Close from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import { FlexColumnDiv } from "./common.styles";
export const HXDialog = styled(Dialog) ``;
export const HXDialogHeader = styled.div `
    width: 100%;
    padding: 16px 24px 0px 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
`;
export const HXDialogTitle = styled(DialogTitle) `
    padding: 0;
    color: ${colors.black_main};
    font-size: ${fontSizes.MEDIUM};
    font-weight: ${fontWeights.SEMI_BOLD};
    line-height: normal;
    letter-spacing: 0.15px;
    flex: 1 0 0;
`;
export const HXDialogContent = styled(DialogContent) `
    padding: 16px 24px 20px 24px;
    color: ${colors.black_main};
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    letter-spacing: 0.15px;
`;
export const HXDialogActions = styled(DialogActions) `
    gap: 8px;
`;
export const HXDialogVerticalActions = styled(FlexColumnDiv) `
    padding: 8px 24px 24px 24px;
    gap: 12px;
`;
const HXDialogCloseButtonEl = styled(HXIconButton) `
    margin-left: auto;
    font-size: 24px !important;
    color: ${colors.black_lighter};
`;
export const HXDialogCloseButton = (props) => {
    return (_jsx(HXDialogCloseButtonEl, { onClick: () => props.onClick(), children: _jsx(Close, {}) }));
};
